"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLINK_APPS = exports.APP_HEADER = void 0;
// The two signed-in apps (D-0008). Each has its own session cookie, so signing out of
// one does not sign out of the other; the courier app names itself with this header.
exports.APP_HEADER = 'x-blink-app';
exports.BLINK_APPS = ['admin', 'courier'];
//# sourceMappingURL=apps.js.map